import React from "react";
import { withRouter } from "react-router-dom";

import { Button } from "aible";
import Select from "react-select";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

class RetargetOutcomeModal extends React.Component {
  state = {
    outcome: this.props.dataset && this.props.dataset.outcome
  };
  componentDidUpdate(prevProps) {
    const { showModal, dataset } = this.props;
    if (showModal && !prevProps.showModal && dataset) {
      this.setState({ outcome: dataset && dataset.outcome });
    }
  }
  render() {
    const { showModal, handleShow, dataset, handleRetarget, outcomeOptions } = this.props;
    const { outcome } = this.state;

    if (!dataset) {
      return <React.Fragment />;
    }

    const finishedIndexing =
      dataset.status &&
      dataset.status.indexOf("indexing") === -1 &&
      dataset.status.indexOf("finishing_indexing") === -1 &&
      !dataset.stack_id;

    return (
      <Dialog open={showModal} onOpenChange={() => handleShow(false)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{dataset.label}</DialogTitle>
          </DialogHeader>
          <div className={styles.retargetModalBody}>
            {finishedIndexing ? (
              <React.Fragment>
                <div className={styles.retargetModalText}>{"Choose a new outcome for " + dataset.label + "."}</div>
                <Select
                  placeholder="Select New Outcome"
                  options={outcomeOptions}
                  value={{ value: outcome, label: outcome }}
                  onChange={(v) => {
                    this.setState({ outcome: v.value });
                  }}
                />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className={styles.retargetModalText}>
                  {"Finishing outcome evaluation for " +
                    dataset.label +
                    ". You cannot change the outcome again until this is complete."}
                </div>
                <LoadingIndicator />
                <div style={{ textAlign: "center", marginTop: "30px" }}>{"This will take a few minutes."}</div>
              </React.Fragment>
            )}
          </div>
          <DialogFooter>
            <Button type="secondary" onClick={() => handleShow(false)}>
              {"Cancel"}
            </Button>
            <Button
              type="primary"
              disabled={!finishedIndexing}
              onClick={() => {
                handleShow(false);
                return handleRetarget(outcome);
              }}
            >
              {"Change Outcome"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withRouter(RetargetOutcomeModal);
